module.exports = __webpack_public_path__ + "img/home-7.c38a90be.png";